define('page/product', [
    'Vue',
    'jquery',
    'component/pagination/index',
    'utils/toast'
], function (Vue, $, vuePagination, toast) {
    var app = new Vue({
        el: "#app",
        data: {
            MenuList: [],
            HotNewsList: [],
            HomeNewsList: [],
            newsInfo: null,
            selMenuIndex: -1,
            recordCount: 0,
            pagehtml: '',
            postdata: {
                showDetail: false,
                pageIndex: 1,
                pageSize: 5, 
                menuId: 0, 
                title: '',
                newsId: 0,
            },
            showPaginatioTotal: false,
            pagerCount: 5,
            showFirstBtn: false,
            showLastBtn: false,
            preViewImg: false, // 文章看图
            preViewImgSrc: '' //文章看图路径
        },
        components: {
            'vue-pagination': vuePagination
        },
        //初始化
        created: function () {
            this.postdata.newsId = $("#newsId").val();
            this.postdata.menuId = $("#menuId").val();
            if (this.postdata.newsId > 0) {
                this.TurnToDetail(this.postdata.newsId);
            }
            this.handleUrlQuery()
            this.GetMenuList();
            this.GetHomeNewsList();
        },
        watch: {
            'postdata.title': {
                deep: true,
                handler: function (n) {
                    if (n == '') {
                        this.GetHomeNewsList()
                    }
                }
            }
        },
        methods: {
            handleUrlQuery: function () {
                var url = window.location.search
                if (url && url.indexOf('search=') > -1) {
                    this.postdata.title = decodeURIComponent(url.split('search=')[1])
                }
            },
            GetMenuList: function () {
                $.post("/dzhome2/GetContentDataList", function (data) {
                    if (data.isok) {
                        app.MenuList = data.dataObj.MenuList;
                        app.HotNewsList = data.dataObj.HotNewsList;
                    }
                });
            },
            //切换分类
            ChangeMenu: function (index) {
                this.selMenuIndex = index;
                if (index >= 0) {
                    this.postdata.menuId = this.MenuList[index].Id;
                    this.MenuName = this.MenuList[index].name;
                } else {
                    this.postdata.menuId = 0;
                    this.MenuName = "全部";
                }
                this.newsInfo = null;
                this.postdata.pageIndex = 1;
                this.postdata.showDetail = false;
                this.GetHomeNewsList();
            },
            //获取列表页数据
            GetHomeNewsList: function () {
                $.post("/dzhome/GetBkNewsList", this.postdata, function (data) {
                    if (data.isok == true) {
                        var list = app.HomeNewsList = data.newsList
                        if (!list || !list.length) {
                            toast.show('该类列表为空')
                        }
                        app.recordCount = data.recordCount;
                    }
                });
            },
            //跳转到内容页 获取内容页数据
            TurnToDetail: function (newsId) {
                $.post("/dzhome/GetBkNews", {
                    newsId: newsId
                }, function (data) {
                    if (data.isok) {
                        app.newsInfo = data.news;
                    } else {
                        layer.msg(data.msg);
                    }
                })
            },
            EnterSeach: function () {
                this.SeachData();
            },
            //搜索关键词
            SeachData: function () {
                this.GetHomeNewsList();
            },
            updateNewsList: function (pageIndex) {
                var postdata = this.postdata
                postdata.pageIndex = pageIndex
                postdata.title = ''
                this.GetHomeNewsList()
            },
            handleArticleClick: function (e) {
                var target = e.target

                if (target.tagName.toLowerCase() !== 'img') {
                    return;
                }

                this.preViewImg = true
                this.preViewImgSrc = target.src
            },
            closePreViewImgMask: function () {
                this.preViewImg = false
            }
        },
    })
});
